"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wordpressGenericTrackingDataPlugin = void 0;
const genericTrackingData_1 = require("../lib/genericTrackingData");
exports.wordpressGenericTrackingDataPlugin = {
    name: 'Wordpress Generic Tracking Data',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    page: (ctx) => {
        var _a, _b;
        try {
            const properties = Object.assign(Object.assign({}, (0, genericTrackingData_1.getGenericTrackingData)()), ((_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.properties) !== null && _b !== void 0 ? _b : {}));
            ctx.updateEvent('properties', properties);
        }
        catch (e) {
            console.log(e);
        }
        return ctx;
    },
};
//# sourceMappingURL=wordpressGenericTrackingData.js.map